import { type AxiosInstance } from "axios";
import type { Order } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 指定された発注の宛先リストファイルを再アップロードする。
 * @param apiClient - axios インスタンス
 * @param id - 発注ID
 * @param file - 再アップロードする宛先リストファイル
 * @returns 更新後の発注情報
 */
export const PostAddressListReuploadAPI = async (
  apiClient: AxiosInstance,
  id: number,
  file: File
): Promise<Order> => {
  const url = `/dm/orders/${id}/address-list/reupload/`;

  // FormDataはJSON→snake_case自動変換(axios-case-converter)の対象外のため、キー名を直接snake_caseで指定する
  const formData = new FormData();
  formData.append("address_list_file", file);

  try {
    const response = await apiClient.post<Order>(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
